// Permissões da sessão. O servidor envia-as em user.permissions (login e /auth/me);
// é ele que decide. Aqui só se esconde o que a pessoa não pode usar.

// Os quatro perfis de sempre, para sessões abertas antes de o servidor enviar
// as permissões (o painel pode ser publicado antes do servidor).
const LEGACY_ROLE_PERMISSIONS = {
  ADMIN: [
    "services.view", "services.edit", "reports.edit", "reminders.send", "members.view", "members.edit",
    "finance.view", "offerings.edit", "plan.view", "plan.edit", "site.edit", "users.manage", "church.edit", "activity.view",
  ],
  SECRETARIA: ["services.view", "services.edit", "reports.edit", "reminders.send", "members.view", "members.edit", "plan.view", "plan.edit"],
  PASTORAL: ["services.view", "services.edit", "reports.edit", "reminders.send", "members.view", "plan.view", "plan.edit"],
  TESOURARIA: ["services.view", "finance.view", "offerings.edit"],
};

export function permissionsOf(user) {
  if (!user) return [];
  if (Array.isArray(user.permissions)) return user.permissions;
  return LEGACY_ROLE_PERMISSIONS[user.role] || [];
}

/** true se a sessão tiver pelo menos uma das permissões indicadas. */
export function can(user, ...permissions) {
  const mine = permissionsOf(user);
  return permissions.flat().some((p) => mine.includes(p));
}
